import { Component } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pse-pending-error',
  templateUrl: './pse-pending-error.component.html',
  styleUrls: ['./pse-pending-error.component.scss']
})
export class PsePendingErrorComponent {
  assetsUrl = environment.assetsUrl;
  private url = 'https://www.avvillas.com.co/';
  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/notification.svg',
    image: 'close-icon',
    title: 'La transacción está pendiente por confirmar',
    bullets: [
      'Te deberá llegar un correo de PSE confirmando si tu transacción fue aprobada o rechazada.',
      `Si la transacción fue rechazada, intenta transferir tu plata antes de 48 horas a través de <a href="${this.url}">avvillas.com.co</a> en la sección ahorro e inversión, selecciona CDT.`,
      'Si la transacción fue aprobada, tu CDT se verá reflejado en tus Canales Digitales en máximo 5 días hábiles.'
    ],
    link: {
      url: this.url,
      text: 'Entendido'
    }
  };
}
